/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const InfoBlack = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C15.9954 12.4164 12.4164 15.9954 8 16Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.68791 11.787H8.0037C7.77116 11.787 7.58265 11.5985 7.58265 11.366V7.57648H6.31949C6.08695 7.57648 5.89844 7.38797 5.89844 7.15543C5.89844 6.92289 6.08695 6.73438 6.31949 6.73438H8.0037C8.23624 6.73438 8.42475 6.92289 8.42475 7.15543V10.9449H9.68791C9.92045 10.9449 10.109 11.1334 10.109 11.366C10.109 11.5985 9.92045 11.787 9.68791 11.787Z" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.99918 5.89515C7.76664 5.89515 7.57812 5.70664 7.57812 5.4741V4.63199C7.57812 4.39945 7.76664 4.21094 7.99918 4.21094C8.23172 4.21094 8.42023 4.39945 8.42023 4.63199V5.4741C8.42023 5.70664 8.23172 5.89515 7.99918 5.89515Z" fill="white"/>
    </BaseSvgIcon>
  )
}

export default InfoBlack
